const normalizeOptions = (options, globalOptions) => {
    options = typeof options === 'object' ? options : Object.create(null);
    return new Proxy(options, {
        get(target, key, receiver) {
            return Reflect.get(target, key, receiver) || Reflect.get(globalOptions, key, receiver);
        },
    });
};
export { normalizeOptions };
//# sourceMappingURL=options.js.map